// extracted by mini-css-extract-plugin
module.exports = {"dropzoneWrap":"Dropzone_dropzoneWrap__2AE17","dropzone":"Dropzone_dropzone__3YMoa"};